module.exports = __webpack_public_path__ + "media/images/creator/logo-5bbe231d5df30032735485dcf8545e88.svg";